import Banner1 from "../../../assets/images/banner/banner-2.svg";
// import Banner1 from "../../../assets/images/banner/auth-banner.svg";
const TitleComponent = () => {
  return (
    <div className="col-md-12 col-lg-7 col-xl-8 p-0 d-none d-lg-block">
    <div className="auth-banner-block">
      <div className="auth-banner-content">
        <h4 className="banner-content-title">Master with AI</h4>
        <p className="banner-content-dsc-text">
          Join thousands of students who are transforming their learning journey with personalized AI assistance.
        </p>
        <div className="auth-banner-img">
          <img src={Banner1} alt="Banner1" />
        </div>
      </div>
    </div>
    </div>
  )
}

export default TitleComponent
